// extracted by mini-css-extract-plugin
export default {"link":"style_link__s7uxa","centerGrid":"style_centerGrid__UVjji","img":"style_img__Ph5ar","namegame":"style_namegame__0GzpH","center":"style_center__wgia2"};